export const Config = {
  version: "0.5.2",
  name: "Monib Web Application",
};

